import { render, staticRenderFns } from "./employees.vue?vue&type=template&id=2ab10c2a"
import script from "./employees.vue?vue&type=script&lang=js"
export * from "./employees.vue?vue&type=script&lang=js"
import style0 from "./employees.vue?vue&type=style&index=0&id=2ab10c2a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports